import { endOfDay, subWeeks } from 'date-fns';
import { apiSlice } from '../apiSlice';
import { UploadSummary } from '../schemas/uploadSummary';
import { filterParamsAdapter } from '../utils/filterParamsAdapter';

const uploadSummaryEndpoints = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUploadSummaries: builder.query<
      UploadSummary[],
      GetUploadSummaryFilter | void
    >({
      query: (params = { date_cutoff: DEFAULT_DATE_CUTOFF }) => ({
        url: `uploadSummaries`,
        params: params ? filterParamsAdapter(params) : undefined,
      }),
    }),
  }),
});

export const { useGetUploadSummariesQuery } = uploadSummaryEndpoints;

type GetUploadSummaryFilter = {
  /**
   * ISO Date string to filter summaries
   * based on their collection date.
   *
   * @default Last 2 weeks if not provided.
   */
  date_cutoff?: string;
};

export const DEFAULT_DATE_CUTOFF = endOfDay(
  subWeeks(new Date(), 2)
).toISOString();
